import { cn } from "@/lib/utils";

// Scroll container for a list page's table: fills the flex-sized area down to
// the pagination bar and applies the compact density (32px header, 40px rows,
// transparent header with no bottom border).
//
// The density itself lives in `.table-dense` in `app.css` rather than in
// Tailwind classes: the legacy `.table-container` padding it has to beat is
// unlayered, so a utility class would be silently inert against it.
export function DenseTableViewport({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}): React.ReactElement {
  return (
    <div
      className={cn(
        "table-dense h-full overflow-x-hidden overflow-y-auto",
        className
      )}
    >
      {children}
    </div>
  );
}
